export enum NzIdWarningCodeType {
    NEW_ID_OVERWRITE_INACTIVE_NZO_WITH_ZERO_EA = 'NEW_ID_OVERWRITE_INACTIVE_NZO_WITH_ZERO_EA',
}
